module.exports = __webpack_public_path__ + "img/cc53d51.jpg";